export const Typography4SX = {
  fontSize: 11,
  fontWeight: 'bold',
  ml: 1,
};
